$(function(){
    var openModal= $('.open-modal');

    openModal.click(function(e){
        e.preventDefault();
        var modalId = $(this).attr('data-modal');
        var videUrl = $(this).attr('data-video');

        $("." + modalId).find('iframe').attr('src', videUrl);
        $("." + modalId).find('iframe').attr('id', 'tagvideo');
        $("." + modalId).fadeIn();
        myfunction()
        
        if($(this).hasClass('open-img')){
            var getImg = $(this).next().find('.slick-current').attr('src');
            $("." + modalId).find('img').attr('src', getImg)
        }
    })
    $(".modal-close").click(function(){
        $(this).parents('.modal').fadeOut('fast');
        // $(this).parents('.modal').find('iframe').attr('src', '');
        stopVideo();
    })
})
function myfunction(){
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

var player;
var myTimer;
function onYouTubeIframeAPIReady() {
    player = new YT.Player( 'tagvideo', {
    events: { 'onStateChange': onPlayerStateChange, 'onReady': onPlayerReady, }
    });
}
function onPlayerReady(event) {
    event.target.playVideo();
  }
function onPlayerStateChange(event) {
    switch(event.data) {
    case 0:
        dataLayer.push({
            'eventCategory': 'Video',
            'eventAction': 'video_consumption_100%',
            'eventLabel': player.playerInfo.videoData.title,
            'eventvalue': '',
            'event': 'videoEvents'
        });
        clearInterval(myTimer);
        break;
    case 1:
        var dur =  parseInt( player.getDuration());
        var p25= parseInt(25 * dur / 100);
        var p50= parseInt(50 * dur / 100);
        var p75= parseInt(75 * dur / 100);
        dataLayer.push({
            'eventCategory': 'Video',
            'eventAction': 'start video playback',
            'eventLabel': player.playerInfo.videoData.title,
            'eventvalue': '',
            'event': 'videoEvents'
        });

        myTimer = setInterval(function(){ 
            if(parseInt(player.getCurrentTime()) == p25){
                dataLayer.push({
                    'eventCategory': 'Video',
                    'eventAction': 'video_consumption_25%',
                    'eventLabel': player.playerInfo.videoData.title,
                    'eventvalue': '',
                    'event': 'videoEvents'
                });
            }else if(parseInt(player.getCurrentTime()) == p50){
                dataLayer.push({
                    'eventCategory': 'Video',
                    'eventAction': 'video_consumption_50%',
                    'eventLabel': player.playerInfo.videoData.title,
                    'eventvalue': '',
                    'event': 'videoEvents'
                });
            }else if(parseInt(player.getCurrentTime()) == p75){
                dataLayer.push({
                    'eventCategory': 'Video',
                    'eventAction': 'video_consumption_75%',
                    'eventLabel': player.playerInfo.videoData.title,
                    'eventvalue': '',
                    'event': 'videoEvents'
                });
            }
        }, 1000);
        break;
    case 2:
        clearInterval(myTimer);
        break;
    }
}
function stopVideo() {
    player.stopVideo();
}